import React, { Component } from 'react'
import '../css/styles.css'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { localize, localizeImg } from '../util/Localizer'
import Config from '../Config'
import {
  fetchBenefitCard,
  fetchStaffBenefitCard,
  fetchStaffBenefitCardBack
} from '../redux/actions/benefitCardActions'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

class BenefitCardContent extends Component {
  getBenefitGroups (benefitCoverages) {
    if (benefitCoverages) {
      let benefitGroups = benefitCoverages.map((item, index) => {
        return index % 2 === 0 ? benefitCoverages.slice(index, index + 2) : null
      })
        .filter(function (item) { return item })
      return benefitGroups
    }
  }

  _returnPhoneNumbers (data, tableTHStyle) {
    const { wlKey } = Config
    if (wlKey === 'iuoe') {
      return (
        <React.Fragment>
          <p style={tableTHStyle.bold}>{localize('print.benefitCard.memberHelpNumber')}: <span>{data.helpLineNumber}</span></p>
          <p style={tableTHStyle.bold}>{localize('print.benefitCard.providerNumber')}: <span>{Config.providerSupportNumber}</span></p>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <p style={tableTHStyle.bold}>{localize('print.benefitCard.providerNumber')}: <span>{Config.providerSupportNumber}</span></p>
          <p style={tableTHStyle.bold}>{localize('print.benefitCard.memberHelpNumber')}: <span>{data.helpLineNumber}</span></p>
        </React.Fragment>
      )
    }
  }

  /**
   * Validates the data that comes from the props `this.props.benefitCard`
   * @param  {object} data
   * @returns bool
   */
  validateBenefitCardData (data) {
    var isValid = (data !== undefined && data !== null)
    if (isValid) {
      isValid = isValid && (data.cardBenefitCoverage !== undefined && data.cardBenefitCoverage !== null)
      isValid = isValid && (data.carrier !== undefined && data.carrier !== null)
      isValid = isValid && (data.cardCoveredLives !== undefined && data.cardCoveredLives !== null)
    }
    return isValid
  }

  render () {
    const logo = localizeImg('/img/logo.svg')
    const {
      benefitCardData = {},
      staffBenefitCard = {},
      staffBenefitCardBack = {}
    } = this.props
    const {
      cardBenefitCoverage = [],
      cardCoveredLives = [],
      carrier = {},
      certificateNumber = '',
      policyName = '',
      policyNumber = '',
      shouldShowRenderedBenefitCard = false,
      travelDescription = ''
    } = benefitCardData
    const { imageData: staffBenefitCardData = '' } = staffBenefitCard
    const { imageData: staffBenefitCardBackData = '' } = staffBenefitCardBack
    const base64String = 'data:image/jpeg;base64, '
    const benefitCardFront = base64String.concat('', staffBenefitCardData)
    const benefitCardBack = base64String.concat('', staffBenefitCardBackData)

    const tableTHStyle = {
      textAlign: 'left',
      letterSpacing: 2,
      bold: {
        fontWeight: 'bold'
      }
    }
    const tableStyle = {
      textAlign: 'left',
      verticalAlign: 'top'
    }

    if (this.validateBenefitCardData(benefitCardData)) {
      const benefitGroups = this.getBenefitGroups(cardBenefitCoverage)
      if (benefitGroups) {
        return (
          <div id='benefitCardContent' className='benefitCardPageContainer'>
            <Grid fluid className='benefitCardPage'>
              <Row>
                <Col xs={2}>
                  <img height='100' width='200' src={logo} alt={localize('pages.login.logoAlt')} />
                </Col>
              </Row>
              <Row top='xs'>
                <Col xs={12}>
                  <h5 style={tableStyle}><p>{localize('print.benefitCard.title')}</p></h5>
                  <p>{policyName}</p>
                </Col>
              </Row>
              {/* coverage info */}
              <Row>
                <Col xs={12}>
                  <table>
                    <thead>
                      <tr>
                        <th style={tableTHStyle}><p>{localize('print.benefitCard.carrier')}</p></th>
                        <th style={tableTHStyle}><p>{localize('print.benefitCard.groupNo')}</p></th>
                        <th style={tableTHStyle}><p>{localize('print.benefitCard.certi')}</p></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={tableStyle}>
                          <p>{`${localize('print.benefitCard.drug')} ${carrier && carrier.bin}`}</p>
                          <p>{`${localize('print.benefitCard.dental')} ${carrier && carrier.carrierNR}`}</p>
                        </td>
                        <td style={tableStyle}><p>{policyNumber}</p></td>
                        <td style={tableStyle}><p>{certificateNumber}</p></td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
              <br />
              <Row className='benefitCoverage'>
                <Col xs={12}>
                  <table>
                    <thead>
                      <tr>
                        <th style={tableTHStyle}><p>{localize('print.benefitCard.benefit')}</p></th>
                        {!Config.member.benefits.hideCoverage && <th style={tableTHStyle}><p>{localize('print.benefitCard.coverage')}</p></th>}
                        <th />
                        <th style={tableTHStyle}>{cardBenefitCoverage && cardBenefitCoverage.length > 1 ? <p>{localize('print.benefitCard.benefit')}</p> : ''}</th>
                        {!Config.member.benefits.hideCoverage && <th style={tableTHStyle}>{cardBenefitCoverage && cardBenefitCoverage.length > 1 ? <p>{localize('print.benefitCard.coverage')}</p> : ''}</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {
                        benefitGroups && benefitGroups.map((coverage, indx) => {
                          return (<tr key={indx}>
                            <td style={tableStyle}><p>{(coverage[0] && coverage[0].benefitType) || ''}</p></td>
                            {!Config.member.benefits.hideCoverage && <td style={tableStyle}><p>{(coverage[0] && coverage[0].benefitCoverage) || ''}</p></td>}
                            <td />
                            <td style={tableStyle}><p>{(coverage[1] && coverage[1].benefitType) || ''}</p></td>
                            {!Config.member.benefits.hideCoverage && <td style={tableStyle}><p>{(coverage[1] && coverage[1].benefitCoverage) || ''}</p></td>}
                          </tr>)
                        })
                      }
                    </tbody>
                  </table>
                  {travelDescription && travelDescription.length > 0 ? <p>{localize('print.benefitCard.travelDescription')}: <span>{travelDescription}</span></p> : ''}
                </Col>
              </Row>
              {/* covered members */}
              <Row>
                <Col xs={4}>
                  <h5><p>{localize('print.benefitCard.coveredMembers')}</p></h5>
                  <table className='familyCoverageChart'>
                    <thead>
                      <tr>
                        <th style={tableTHStyle}><p>{localize('print.benefitCard.name')}</p></th>
                        <th style={tableTHStyle}><p>{localize('print.benefitCard.relationship')}</p></th>
                        <th style={tableTHStyle}><p>{localize('print.benefitCard.patientCode')}</p></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cardCoveredLives.map((member, i) => {
                        return (
                          <tr key={i}>
                            <td style={tableStyle}><p>{`${member.firstName} ${member.middleName} ${member.lastName}`}</p></td>
                            <td style={tableStyle}><p>{member.relationship}</p></td>
                            <td style={tableStyle}><p>{member.patientId}</p></td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </Col>
              </Row>
              {/* conditions */}
              <Row>
                <Col xs={12}>
                  <h5><p>{localize('print.benefitCard.conditionLabel')}</p></h5>
                  <p dangerouslySetInnerHTML={{ __html: localize('print.benefitCard.conditions') }} />

                  {this._returnPhoneNumbers(benefitCardData, tableTHStyle)}
                </Col>
              </Row>
              {shouldShowRenderedBenefitCard && <Row>
                <Col xs={4}><img alt='' src={benefitCardFront} width='400' /></Col>
                <Col xs={4}><img alt='' src={benefitCardBack} width='400' /></Col>
              </Row>}
            </Grid>
          </div>
        )
      }
    }
    return (
      <div className='benefitCardPageContainer' />
    )
  }
}

class BenefitCard extends Component {
  componentDidMount () {
    const {
      benefitCardData = '',
      benefitCard = ''
    } = window.localStorage

    if (!benefitCardData) {
      this.props.fetchBenefitCard()
    } else {
      const nextbenefitCardData = JSON.parse(benefitCardData)
      if (nextbenefitCardData.shouldShowRenderedBenefitCard && !benefitCard) {
        this.props.fetchStaffBenefitCard()
        this.props.fetchStaffBenefitCardBack()
      }
    }
  }

  render () {
    const {
      benefitCardData = '',
      benefitCard = '',
      benefitCardBack = ''
    } = window.localStorage

    if (!benefitCardData) {
      return <div className='hidden' />
    } else {
      const parsedData = JSON.parse(benefitCardData)
      const { shouldShowRenderedBenefitCard = false } = parsedData

      let staffBenefitCard = {}
      let staffBenefitCardBack = {}
      if (benefitCard && benefitCardBack) {
        staffBenefitCard = shouldShowRenderedBenefitCard ? JSON.parse(benefitCard) : {}
        staffBenefitCardBack = shouldShowRenderedBenefitCard ? JSON.parse(benefitCardBack) : {}
      }

      return (
        <div className='hidden'>
          <BenefitCardContent
            benefitCardData={parsedData}
            staffBenefitCard={staffBenefitCard}
            staffBenefitCardBack={staffBenefitCardBack}
          />
        </div>
      )
    }
  }
}

function mapStateToProps (state, ownProps) {
  return {
    isLoading: state.BenefitCardReducer.isLoading,
    benefitCard: state.BenefitCardReducer.benefitCard,
    staffBenefitCard: state.BenefitCardReducer.staffBenefitCard,
    staffBenefitCardBack: state.BenefitCardReducer.staffBenefitCardBack,
    error: state.BenefitCardReducer.error
  }
}

const ConnectedBenefitCard = connect(mapStateToProps, {
  fetchBenefitCard,
  fetchStaffBenefitCard,
  fetchStaffBenefitCardBack
})(injectIntl(BenefitCard))

export default ConnectedBenefitCard



// WEBPACK FOOTER //
// ./src/components/BenefitCard.js